/**
 * Funtion to copy a text to the clipboard.
 *
 * @param item String to be copied to clipboard
 */
export function copyToClipboard(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/copyToClipboard.ts